import React, { useState } from "react";
import { toast } from "react-hot-toast";

function Veriler() {
  const [selectedCard, setSelectedCard] = useState(null);
  const [isToggleOn, setIsToggleOn] = useState(false);

  const handleOpenPopup = (index) => {
    setSelectedCard(index);
  };

  const handleClosePopup = () => {
    setSelectedCard(null);
  };

  const handleToggleClick = () => {
    setIsToggleOn((prev) => !prev);
    toast(isToggleOn ? "Bakım modu kapatıldı!" : "Bakım modu açıldı!", {
      icon: isToggleOn ? "❌" : "✅",
    });
  };

  return (
    <div
      className="bg-sky-100 min-h-screen p-6 rounded shadow"
      style={{
        marginBottom: 20,
      }}
    >
      {/* Header */}
      <header>
        <h1 className="text-3xl font-bold">Uygulama Verileri</h1>
        <hr className="mt-4 border-gray-400 rounded" />
      </header>

      {/* Content */}
      <main className="p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {Array.from({ length: 40 }).map((_, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded shadow hover:shadow-lg transition cursor-pointer"
            onClick={() => handleOpenPopup(index)}
          >
            <h2 className="text-xl font-semibold text-gray-800">Ayar {index + 1}</h2>
            <p className="text-sm text-gray-600 mt-2">
              Bu, Ayar {index + 1} için bir açıklama.
            </p>
          </div>
        ))}
      </main>

      {/* Popup */}
      {selectedCard !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded shadow-lg">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Ayar {selectedCard + 1}
            </h2>
            <p className="text-gray-600 mb-4">
              Ayar {selectedCard + 1} ile ilgili daha fazla bilgi burada yer alacak.
            </p>
            <table className="w-full border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border px-4 py-2 text-left">Sütun 1</th>
                  <th className="border px-4 py-2 text-left">Sütun 2</th>
                  <th className="border px-4 py-2 text-left">Sütun 3</th>
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: 5 }).map((_, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className="border px-4 py-2">Veri {rowIndex + 1}.1</td>
                    <td className="border px-4 py-2">Veri {rowIndex + 1}.2</td>
                    <td className="border px-4 py-2">Veri {rowIndex + 1}.3</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button
              className="mt-6 bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
              onClick={handleClosePopup}
            >
              Kapat
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Veriler;
